import styled from 'styled-components';
import Card from '@mui/material/Card';
import { COLORS } from '../../../../values/colors';
import { motion } from 'framer-motion';

export const StyledCard = styled(Card)`
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4) !important",
  &:hover {
    boxShadow: "0px 4px 8px rgba(3, 0, 0, 0.5) !important",
  }
`;

export const StyledCardContent = styled.div`
  padding: 16px;
  text-align: center;
  background-color: ${COLORS.gray};
`;

export const Heading = styled(motion.h1)`
    font-size: 2rem;
    color: ${COLORS.textPrimary};
    font-weight: 600;
    margin: 0;
`;

export const Rectangle = styled(motion.div)`
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  height: 0.15rem;
  background-color: ${COLORS.apronBrown};
  margin-top: 1rem;
  margin-bottom: 1rem;
`;


